import style from "./FilterOut.css";

export const FilterOut = () => <div className={style.wrapper} />;

FilterOut.propTypes = {};

FilterOut.displayName = "FilterOut";

export default FilterOut;
